module.exports = __webpack_public_path__ + "static/media/elementLoader.dcfd0173.svg";